import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import apiService from '../services/api';

interface TimezoneSettings {
  timezone: string;
}

export const useTimezoneSettings = () => {
  const { trainer } = useAuth();
  const [settings, setSettings] = useState<TimezoneSettings | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  const fetchSettings = async () => {
    if (!trainer) return;

    try {
      setIsLoading(true);
      const response = await apiService.getTimezoneSettings();
      setSettings(response);
    } catch (error) {
      console.error('Error fetching timezone settings:', error);
      // Устанавливаем настройки по умолчанию
      setSettings({
        timezone: 'Europe/Moscow'
      });
    } finally {
      setIsLoading(false);
    }
  };

  const saveSettings = async (newSettings: TimezoneSettings) => {
    if (!trainer) return;

    try {
      setIsSaving(true);
      
      const response = await apiService.saveTimezoneSettings(newSettings);
      setSettings(newSettings);
      return response;
    } catch (error) {
      console.error('Error saving timezone settings:', error);
      throw error;
    } finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, [trainer]);

  return {
    settings,
    isLoading,
    isSaving,
    saveSettings,
    refetch: fetchSettings,
  };
}; 